module.exports = __webpack_public_path__ + "media/images/lb/699-b4e16fc53bfe22892c3d4df8e83c6146.svg";